import normalizeWheel from 'normalize-wheel';
import type { IkeDraw } from '../../draw';

const PIXELS_PER_ZOOM = 240;

export const SVGWheel = {
	/**
	 * Milliseconds to wait between zoom ticks
	 */
	DEBOUNCE_TIME: 40,

	getEventType: () => normalizeWheel.getEventType(),

	delta: 0,
	startTime: 0,
	timer: 0,

	onWheel(dc: IkeDraw, e: WheelEvent) {
		var delta = normalizeWheel(e);

		SVGWheel.delta += delta.pixelY;
		if (SVGWheel.startTime === 0) {
			SVGWheel.startTime = +new Date();
		}

		var left = Math.max(SVGWheel.DEBOUNCE_TIME - (+new Date() - SVGWheel.startTime), 0);
		clearTimeout(SVGWheel.timer);
		SVGWheel.timer = setTimeout((_) => {
			// Use the leaflet method for calculating ZoomChange
			// https://github.com/Leaflet/Leaflet/blob/master/src/map/handler/Map.ScrollWheelZoom.js#L67
			// map the delta with a sigmoid function to -4..4 range leaning on -1..1
			const d2 = SVGWheel.delta / (PIXELS_PER_ZOOM * 4);
			const d3 = (4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2))))) / Math.LN2;
			const d4 = 1 + d3;
			const actualDelta = SVGWheel.delta > 0 ? 1 / d4 : d4;

			dc.boundEvents.mousewheel(actualDelta, e);
			SVGWheel.delta = 0;
		}, left) as any;

		if (e.preventDefault) {
			e.preventDefault();
		}

		if (e.stopPropagation) {
			e.stopPropagation();
		}
	},
};
